import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { SIDEBAR_WIDGET_CARD_SX } from "../sidebar-widgets/sidebarWidgetStyles";

export default function ContentNotesPanel({ row, disabled, onAdd, onEdit, onViewAll, sidebar = false }) {
  return <Box sx={sidebar ? { ...SIDEBAR_WIDGET_CARD_SX, p: 4 } : {}}>
    <Typography component="h2" sx={{ color: "#3451F4", fontSize: 18, fontWeight: 600, mb: 3 }}>Notes</Typography>
    <Button fullWidth disabled={disabled} onClick={onAdd} sx={{ border: "1px dashed #9C4FFF", borderRadius: "12px", minHeight: 78, color: "#9C4FFF", textTransform: "none", fontSize: 14, mb: 3 }}>Add New Note</Button>
    <Typography component="h3" sx={{ fontSize: 14, fontWeight: 500, mb: 1.5 }}>Previous Notes</Typography>
    {row.note_body ? <Box sx={{ mb: 2 }}>
      <Button disabled={disabled} onClick={onEdit} sx={{ p: 0, textTransform: "none", justifyContent: "flex-start", color: "#9C4FFF" }}>{row.note_title || "Note"}</Button>
      <Typography sx={{ fontSize: 14, color: "#475467", whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{row.note_body}</Typography>
    </Box> : <Typography sx={{ fontSize: 13, color: "#98A2B3", mb: 2 }}>No previous notes yet.</Typography>}
    <Box sx={{ borderTop: "1px solid #D0D5DD", pt: 1.5, display: "flex", justifyContent: "flex-end" }}>
      <Button onClick={onViewAll} sx={{ p: 0, color: "#9C4FFF", textTransform: "none", fontSize: 14 }}>View All Notes</Button>
    </Box>
  </Box>;
}
